<mat-card class="mt-5">
  <mat-toolbar
    class="page-header flex justify-content-between px-4 pt-2 pb-1 h-auto flex-column md:flex-row">
    <div class="align-items-center">
      <shared-title class="m-0">{{ title }}</shared-title>
      @if (subtitle) {
      <div class="text-xl">{{ subtitle }}</div>
      }
    </div>
    <div
      class="flex flex-wrap justify-content-end gap-3 align-items-baseline sm:align-items-center my-3  flex-column sm:flex-row ">
      <ng-content /><!--gap-3 flex justify-content-end align-items-baseline sm:align-items-center my-3 flex-column sm:flex-row-->
    </div>
  </mat-toolbar>
</mat-card>
